// extracted by mini-css-extract-plugin
export var background = "_65-0";
export var container = "_65-1";
export var contentItem = "_65-7";
export var extendedWarranty = "_65-5";
export var link = "_65-d";
export var modal = "_65-b";
export var modalCloseButton = "_65-9";
export var modalContent = "_65-3";
export var modalContentMain = "_65-6";
export var modalImageLogo = "_65-8";
export var modalLogo = "_65-a";
export var modalSideImage = "_65-4";
export var preview = "_65-c";
export var redoModal = "_65-2";